module.exports = __webpack_public_path__ + "img/nav-l.3a6789e3.svg";